import TW from '../img/Twitter Icon.svg'
import FB from '../img/Facebook Icon.svg'
import Inst from '../img/Instagram Icon.svg'
import Git from '../img/GitHub Icon.svg'

function Footer() {
    return (
    <div className='footer'>
      <a href='https://www.facebook.com/omar.sosa.58/' target='_blank'><img  src={FB}></img></a>
      <a href='https://www.instagram.com/omar.sosa.58/' target='_blank'><img  src={Inst}></img></a>
      <a href='https://github.com/SirZosa' target='_blank'><img  src={Git}></img></a>
    </div>
    );
  }
  
  export default Footer;